import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

import "./CSS/historyicon.css";
import { CurrencyFormatter } from "../helper/CurrencyFormatter";
import axios from "axios";

function HistoryIcon({ pod, data }) {
  const [pId, setpId] = useState("");
  const navigate = useNavigate();

  const handleGoToDetail = (id) => {
    navigate(`${id}`);
    console.log(id);
  };

  const handleDelete = () => {
    // let pid = id;
    axios
      .delete({
        url: `${process.env.REACT_APP_HOST_API}/transaction?id=${pId}`,
      })
      .then((result) => {
        console.log(result);
      })
      .catch((err) => console.log(err));
  };
  // console.log(pId);
  return (
    <>
      <div className="history-icon d-flex">
        <div
          className="history-product-icon"
          onClick={() => handleGoToDetail(data.products_id)}
        >
          <img src={`${data.image}`} alt="product-img" />
        </div>
        <div className="history-product-details">
          <p className="history-product-name">{data.product_name}</p>
          <p className="history-product-price">
            {CurrencyFormatter.format(data.total_price)}
          </p>
          <p className="history-product-status">{data.delivery}</p>
        </div>
        <input
          type="checkbox"
          value={data.id}
          onChange={(e) => {
            setpId(e.target.value);
          }}
        />
        <div className="delete-one-history" onClick={handleDelete}></div>
      </div>
    </>
  );
}

export default HistoryIcon;
